import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../../core/services/language.service';
import { FilterTypes } from '../filters/enums/filter-types.enum';

@Pipe({
  name: 'searchFilterType',
  standalone: true,
})
@Injectable()
export class SearchFilterTypePipe implements PipeTransform {

  private i18nMap: { [key in FilterTypes]: string } = {
    [FilterTypes.CLASS]: this.translate('shared.pipes.searchFilterType.class'),
    [FilterTypes.EQUIPMENT_CLASS]: this.translate('shared.pipes.searchFilterType.class'),
    [FilterTypes.TYPE]: this.translate('shared.pipes.searchFilterType.type'),
    [FilterTypes.EQUIPMENT_TYPE]: this.translate('shared.pipes.searchFilterType.equipmentType'),
    [FilterTypes.LABEL]: this.translate('shared.pipes.searchFilterType.label'),
    [FilterTypes.ORGANISATION]: this.translate('shared.pipes.searchFilterType.organization'),
    [FilterTypes.STATUS]: this.translate('shared.pipes.searchFilterType.status'),
    [FilterTypes.CONTACT_STATE]: this.translate('shared.pipes.searchFilterType.contactStatusName'),
    [FilterTypes.EMPLOYEE_STATE]: this.translate('shared.pipes.searchFilterType.employeeStatusName'),
    [FilterTypes.EQUIPMENT_STATE]: this.translate('shared.pipes.equipmentFields.equipmentStatusName'),
    [FilterTypes.PROJECT_STATE]: this.translate('shared.pipes.searchFilterType.projectStatusName'),
    [FilterTypes.SUBEQUIPMENT]: this.translate('shared.pipes.searchFilterType.subequipment'),
    [FilterTypes.RESPONSIBLE_PERSON]: this.translate('shared.pipes.searchFilterType.responsiblePerson'),
    [FilterTypes.TRANSPORT_TYPE]: this.translate('shared.pipes.searchFilterType.transportType'),
    [FilterTypes.TRANSPORT_STATE]: this.translate('shared.pipes.searchFilterType.state'),
    [FilterTypes.TRANSPORT_RELATED_PROJECT]: this.translate('shared.pipes.searchFilterType.relatedProject'),
    [FilterTypes.PRIORITY]: this.translate('shared.pipes.searchFilterType.priority'),
    [FilterTypes.TRANSPORT_ASSIGNED_VEHICLE]: this.translate('shared.pipes.searchFilterType.assignedVehicle'),
    [FilterTypes.TRANSPORT_VEHICLE]: this.translate('shared.pipes.searchFilterType.transportVehicle'),
    [FilterTypes.FAVOURITE_EQUIPMENT]: this.translate('shared.pipes.searchFilterType.favouriteEquipment'),
    [FilterTypes.MAINTENANCE_TYPE]: this.translate('shared.pipes.searchFilterType.maintenanceType'),
    [FilterTypes.ARTICLE_GROUPS]: this.translate('shared.pipes.searchFilterType.articleGroups'),
    [FilterTypes.EQUIPMENT_LOCATIONS]: this.translate('shared.pipes.searchFilterType.currentLocation'),
    [FilterTypes.DUE_DATE]: this.translate('shared.pipes.searchFilterType.dueDate'),
    [FilterTypes.WN_DUE_DATE]: this.translate('shared.pipes.searchFilterType.taskStatus'),
    [FilterTypes.MAINTENANCE_CATEGORY]: this.translate('shared.pipes.searchFilterType.maintenanceCategory'),
    [FilterTypes.MAINTENANCE_RESULT]: this.translate('shared.pipes.searchFilterType.maintenanceResult'),
    [FilterTypes.CATEGORY]: this.translate('shared.pipes.searchFilterType.category'),
    [FilterTypes.ONLY_LATEST_COMPLETED_FOR_RULE]: this.translate('shared.pipes.searchFilterType.latestResult'),
    [FilterTypes.CHARGE_TYPE]: this.translate('shared.pipes.searchFilterType.chargeType'),
    [FilterTypes.SOURCE_LOCATION]: this.translate('shared.pipes.searchFilterType.sourceLocation'),
    [FilterTypes.SOURCE_LOCATION_ORGANISATION]: this.translate('shared.pipes.searchFilterType.sourceLocationOrganisation'),
    [FilterTypes.TARGET_LOCATION]: this.translate('shared.pipes.searchFilterType.targetLocation'),
    [FilterTypes.TARGET_LOCATION_ORGANISATION]: this.translate('shared.pipes.searchFilterType.targetLocationOrganisation'),
    [FilterTypes.LOCATION]: this.translate('shared.pipes.searchFilterType.location'),
    [FilterTypes.EQUIPMENT_ORGANISATION]: this.translate('shared.pipes.searchFilterType.organizationEquipment'),
    [FilterTypes.ATTENTION_STATUS]: this.translate('shared.pipes.searchFilterType.attentionStatus'),
    [FilterTypes.ACTIVITY_STATUS]: this.translate('shared.pipes.searchFilterType.activityStatus'),
    [FilterTypes.COMPLETENESS_STATUS]: this.translate('shared.pipes.searchFilterType.coreData'),
    [FilterTypes.TRANSFER_TYPE]: this.translate('shared.pipes.searchFilterType.transferType'),
    [FilterTypes.LAST_SEEN]: this.translate('shared.pipes.searchFilterType.lastSeen'),
    [FilterTypes.MODEL]: this.translate('modules.equipment.base.model.s'),
    [FilterTypes.MANUFACTURER]: this.translate('general.manufacturer'),
    [FilterTypes.PROJECT]: this.translate('general.project.s'),
    [FilterTypes.STOCK]: this.translate('general.stock.s'),
    [FilterTypes.MATCH_ALL_LABELS]: this.translate('modules.equipment.equipmentList.flexibleMatch'),
    [FilterTypes.CONSTRUCTION_YEAR]: this.translate('shared.pipes.searchFilterType.productionYear'),
    [FilterTypes.CUSTOMER]: this.translate('general.customer.s'),
    [FilterTypes.EQUIPMENT_TRANSFER_STATUS]: this.translate('shared.pipes.searchFilterType.transferStatus'),
    [FilterTypes.GEOFENCE_TYPE]: this.translate('shared.geofence.type'),
    [FilterTypes.ONLY_DISPOSITION_GEOFENCES]: this.translate('shared.geofence.dispositionOnly'),
    [FilterTypes.ALARM_TYPE]: this.translate('modules.notification.base.alarmType'),
    [FilterTypes.ALARM_LEVEL]: this.translate('modules.notification.notificationList.alarmLevel'),
    [FilterTypes.SELECTION_TYPE]: this.translate('modules.notification.notificationList.selectBy'),
    [FilterTypes.DEFAULT_EMAIL_RECIPIENTS]: this.translate('modules.notification.alarmSettings.defaultAlarmRecipients'),
    [FilterTypes.LABELS]: this.translate('shared.pipes.searchFilterType.label'),
    [FilterTypes.EQUIPMENT_TYPES]: this.translate('shared.pipes.searchFilterType.equipmentType'),
    [FilterTypes.EQUIPMENTS]: this.translate('shared.pipes.searchFilterType.equipment'),
  };

  constructor(protected languageService: LanguageService) { }

  transform(value: FilterTypes | string): string {
    return value in this.i18nMap
      ? this.i18nMap[value as FilterTypes]
      : value;
  }

  private translate(key: string): string {
    return this.languageService.getInstant(key);
  }
}
